import { NotifyHelper } from "../../../helpers/toast";
import { eMonHocActionObj } from "../../action-types/category/IMonHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const MonHocActions = {
    ...generateActions(eMonHocActionObj,"MON_HOC"),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","LOAD_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","SAVE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","DELETE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","SAVE_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","DELETE_ERROR", (m) => {NotifyHelper.Error(m)}),
     ...generateActionForKey(eMonHocActionObj, "MON_HOC","SAVE_CONG_THUC_SUCCESS", (m) => {NotifyHelper.Success("Cập nhật công thức thành công")}),
    ...generateActionForKey(eMonHocActionObj, "MON_HOC","SAVE_CONG_THUC_ERROR", (m) => {NotifyHelper.Error(m)}),
}